import { ArrowUp } from 'lucide-react';

const footerLinks = {
  servicios: [
    { name: 'Construcción de Inmuebles', href: '#servicios' },
    { name: 'Administración de Proyectos', href: '#servicios' },
    { name: 'Desarrollo de Terrenos', href: '#servicios' },
    { name: 'Ingeniería Civil', href: '#servicios' },
    { name: 'Consultoría', href: '#servicios' },
  ],
  empresa: [
    { name: 'Sobre Nosotros', href: '#nosotros' },
    { name: 'Blog', href: '#blog' },
    { name: 'Contacto', href: '#contacto' },
  ],
  contacto: [
    { name: 'contacto@faraci.com.mx', href: 'mailto:contacto@faraci.com.mx' },
    { name: '+52 33 2246 8176', href: 'tel:+523322468176' },
    { name: 'Ixtlahuacan de los Membrillos, Jalisco', href: '#contacto' },
  ],
};

export const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSection = (href) => {
    if (href.startsWith('#')) {
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer data-testid="footer" className="bg-[#0F172A] text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1 flex flex-col items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_d969f8a4-cc05-414e-b246-ef00347927ad/artifacts/xzse4tpn_Faraci%20-01.png"
              alt="Faraci Edificaciones Logo"
              style={{ height: '9rem' }}
              className="w-auto mb-4"
            />
            <p className="font-manrope text-slate-400 text-sm leading-relaxed mb-6">
              Construyendo el futuro de México con excelencia técnica, 
              gestión integral y compromiso sostenible desde 2019.
            </p>
          </div>

          {/* Services Links */}
          <div>
            <h4 className="font-oswald text-lg uppercase tracking-wider mb-6 text-[#92D050]">
              Servicios
            </h4>
            <ul className="space-y-3">
              {footerLinks.servicios.map((link) => (
                <li key={link.name}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    data-testid={`footer-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                    className="footer-link font-manrope text-slate-400 text-sm hover:text-[#92D050] transition-colors duration-300"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="font-oswald text-lg uppercase tracking-wider mb-6 text-[#92D050]">
              Empresa
            </h4>
            <ul className="space-y-3">
              {footerLinks.empresa.map((link) => (
                <li key={link.name}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    data-testid={`footer-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                    className="footer-link font-manrope text-slate-400 text-sm hover:text-[#92D050] transition-colors duration-300"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-oswald text-lg uppercase tracking-wider mb-6 text-[#92D050]">
              Contacto
            </h4>
            <ul className="space-y-3">
              {footerLinks.contacto.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    data-testid={`footer-contact-${link.name.toLowerCase().replace(/[@.\s+]/g, '-')}`}
                    className="footer-link font-manrope text-slate-400 text-sm hover:text-[#92D050] transition-colors duration-300"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="font-manrope text-slate-500 text-sm">
              © {new Date().getFullYear()} Faraci Edificaciones. Todos los derechos reservados.
            </p>
            
            {/* Back to Top */}
            <button
              onClick={scrollToTop}
              data-testid="back-to-top"
              className="flex items-center gap-2 text-slate-400 hover:text-[#92D050] transition-colors duration-300 font-manrope text-sm"
            >
              Volver arriba
              <ArrowUp className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};
